/* Category door videos (2026-09-23). Loaded only when a door carries a video.
 *
 * The door's photograph stays in the markup and on screen until the video is actually playing, so the
 * page never depends on this script: without it, with motion turned off, or on a data-saving connection,
 * the visitor sees the photograph. A video's file is fetched only when its door comes near the screen,
 * loops while at least half of it is visible, and pauses when it leaves or the tab is hidden.
 * Boomerangs are made before upload (forward then backward in one file); the door simply loops it.
 */
(function () {
  'use strict';
  if (window.__doorVideos) return;
  window.__doorVideos = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = navigator.connection && navigator.connection.saveData;
  if (reduce || saveData || !('IntersectionObserver' in window)) return;

  var videos = [];

  function load(v) {
    if (v.__loaded) return;
    v.__loaded = true;
    v.src = v.getAttribute('data-src');
    v.preload = 'auto';
  }
  function play(v) {
    if (!v.__visible || document.hidden) return v.pause();
    load(v);
    var p = v.play();
    if (p && p.catch) p.catch(function () { /* autoplay refused: the photograph stays */ });
  }

  var near = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { load(e.target); near.unobserve(e.target); } });
  }, { rootMargin: '300px 0px' });
  var seen = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { e.target.__visible = e.intersectionRatio >= 0.5; play(e.target); });
  }, { threshold: [0, 0.5] });

  function attach(root) {
    (root || document).querySelectorAll('video.door-video[data-src]').forEach(function (v) {
      if (v.__door) return;
      v.__door = true;
      v.loop = true;
      v.addEventListener('playing', function () { v.classList.add('is-playing'); });
      videos.push(v);
      near.observe(v);
      seen.observe(v);
    });
  }

  document.addEventListener('visibilitychange', function () { videos.forEach(play); });
  document.addEventListener('shopify:section:load', function (e) { attach(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('video.door-video').forEach(function (v) {
      v.pause(); near.unobserve(v); seen.unobserve(v);
      var i = videos.indexOf(v); if (i > -1) videos.splice(i, 1);
    });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { attach(); });
  else attach();
})();
